export default __webpack_public_path__ + "static/2-4-0-0-402cec2e178b986d74b5108c6544500a.jpg";